// Blog API client - calls the blog-api Edge Function

const PROJECT_ID = import.meta.env.VITE_SUPABASE_PROJECT_ID || 'qfozcnxbtjjmidhjdepc';
const BASE_URL = `https://${PROJECT_ID}.supabase.co/functions/v1/blog-api`;
const ANON_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  dek: string | null;
  content: any;
  cover_url: string | null;
  is_featured: boolean;
  view_count: number;
  published_at: string | null;
  created_at: string;
  updated_at: string | null;
  seo: any;
  authors: { id: string; name: string; slug: string; bio?: string; avatar_url?: string } | null;
  categories: { id: string; name: string; slug: string } | null;
  tags?: { id: string; name: string; slug: string }[];
}

export interface BlogListResponse {
  posts: BlogPost[];
  total: number;
  page: number;
  totalPages: number;
}

export interface BlogCategory {
  id: string;
  name: string;
  slug: string;
  description: string | null;
}

async function fetchBlogApi<T>(path: string): Promise<T> {
  const res = await fetch(`${BASE_URL}/${path}`, {
    headers: {
      apikey: ANON_KEY,
      Authorization: `Bearer ${ANON_KEY}`,
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Erro desconhecido' }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const blogApi = {
  listPosts: (params?: { page?: number; limit?: number; category?: string; featured?: boolean }) => {
    const qs = new URLSearchParams();
    if (params?.page) qs.set('page', String(params.page));
    if (params?.limit) qs.set('limit', String(params.limit));
    if (params?.category) qs.set('category', params.category);
    if (params?.featured) qs.set('featured', 'true');
    const query = qs.toString();
    return fetchBlogApi<BlogListResponse>(`posts${query ? '?' + query : ''}`);
  },

  getPost: (slug: string) => fetchBlogApi<BlogPost>(`post/${slug}`),

  getCategories: () => fetchBlogApi<BlogCategory[]>('categories'),
};
